import React, { useEffect } from 'react'
import alert from '../../assets/integrations/airbnbalert.svg'
import { Trans, useTranslation } from 'react-i18next'
import styled, { theme } from '../../theme'
import Button from '../../components/Template/Button'
import { is } from '../../components/MediaQuery'
import Flex from 'typescript-styled-flex'
import Modal, {
  ModalHeader,
  ModalHeaderLabel,
} from '../../components/Template/Modal'
import { Mixpanel } from '../../utils/Mixpanel'

const Info = styled.div`
  background-size: cover;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  color: #696a6d;
  text-decoration: none solid rgb(105, 106, 109);
  text-align: justify;
`
function DeleteModal({ open, id, handleClose, action }: IListingModal) {
  const { t } = useTranslation()
  const isDesktop = is.desktop()

  useEffect(() => {
    if (open) {
      Mixpanel.track('Employees List Delete Screen View', {
        'Employee ID': id,
      })
    }
  }, [open, id])

  return (
    <Modal
      open={open}
      onClose={handleClose}
      deleteModal={true}
      style={{
        marginBottom: isDesktop ? '30vh' : 0,
        width: isDesktop ? 'unset' : '90vw',
        maxWidth: isDesktop ? '45em' : '30em',
        minWidth: isDesktop ? '30em' : '10em',
      }}
    >
      <ModalHeader>
        <Flex style={{ fontWeight: 600, width: '100%' }} justifyStart={true}>
          <ModalHeaderLabel>{t('room_confirm_delete_title')}</ModalHeaderLabel>
        </Flex>
      </ModalHeader>

      <div
        style={{
          color: theme.colors.palette.pinkishTan,
          marginTop: '10px',
          overflowWrap: 'break-word',
        }}
      >
        {t('BED_3607_do_you_delete_employee')}
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginTop: '10px',
        }}
      >
        <img
          src={alert}
          alt={'alert'}
          style={{
            filter:
              'invert(72%) sepia(0%) saturate(1065%) hue-rotate(243deg) brightness(85%) contrast(91%) grayscale(1)',
            width: '40px',
            height: '38px',
            marginRight: '10px',
          }}
        />
        <Info>{t('BED_3607_employee_no_use_application_text')}</Info>
      </div>

      <Flex row={true} justifyEnd={true} style={{ marginTop: '10px' }}>
        <Button
          outline={true}
          onClick={handleClose}
          style={{ marginRight: '25px' }}
        >
          <Trans i18nKey={'cancel'} />
        </Button>
        <Button onClick={action} delete={true}>
          <Trans i18nKey={'delete'} />
        </Button>
      </Flex>
    </Modal>
  )
}

export interface IListingModal {
  open: boolean
  handleClose: () => void
  action: () => void
  id?: string
}

export default DeleteModal
